import { createAppSlice } from "../../app/createAppSlice";

const initialState = {
    "searchResults": []
};

const fevirSearchResultsSlice = createAppSlice({
    name: "fevirSearchResults",
    initialState,
    reducers: create => ({
        changeFevirSearchResults: create.reducer((state, action) => {
            let body = action.payload;
            state.searchResults = body.searchResults || [];
        }),
    }),
    selectors: {
        selectFevirSearchResults: fevirSearchResults => fevirSearchResults
    },
})

export const { changeFevirSearchResults } = fevirSearchResultsSlice.actions

export const { selectFevirSearchResults } = fevirSearchResultsSlice.selectors

export default fevirSearchResultsSlice